import { ArchiveTitleRule } from './archive-title-rule.model';
import { ArchiveFileTitleRuleFormInfo } from './archive-file-title-rule-form-info.model';
export class ArchiveFileTitleRule extends ArchiveTitleRule {
  catalogId?: number;
  fileTitleRuleFormInfos?: Array<ArchiveFileTitleRuleFormInfo>;
  comment?: string;
}
